import React from 'react';
import { 
	object, 
	string, 
	oneOfType,
	func,
} from 'prop-types';
import {Mobile} from '../../Sizes';
import style from './style';

const Presenter = ({
	error,
	onCloseRecipe
}) =>{
	return <style.Wrapper>
		<Mobile>
			<style.IconButton onClick={onCloseRecipe}>
				<style.ArrowLeftIcon  />				
			</style.IconButton>
		</Mobile>
		<style.Error.Text>
			{error}
		</style.Error.Text>
	</style.Wrapper>;
};
Presenter.propTypes = {
	error:oneOfType([string,object]),
	onCloseRecipe:func.isRequired
};

export default Presenter;